import React from 'react';

interface SwitchProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
}

export default function Switch({ checked, onChange, label }: SwitchProps) {
  return (
    <label className="t-switch" style={{ gap: 8, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      <span className="track" />
      {label && <span style={{ fontSize: 'var(--fs-base)', color: 'var(--ink-2)' }}>{label}</span>}
    </label>
  );
}
